exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".powered-by{\n    width:240px;\n    margin-bottom: 20px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/oneills-web-qa/src/app/make-payment-eft/make-payment-eft.component.css
// module id = ../../../../../src/app/make-payment-eft/make-payment-eft.component.css
// module chunks = main